import RelatedTile from '../bundles/RelatedTile';
import { BundleOut } from '../../store/api';
import { Author } from '../../../models/Product';

export function RelatedBundlesForAuthors({
    relatedBundlesByAuthor,
    authors
}: {
    relatedBundlesByAuthor: { readonly [authorId: string]: BundleOut[] } | undefined;
    authors: ReadonlyArray<Author> | undefined;
}) {
    if (!relatedBundlesByAuthor || Object.keys(relatedBundlesByAuthor).length < 1 || !authors) {
        return null;
    }

    const authorIds = Object.keys(relatedBundlesByAuthor);

    return (
        <div className="authorBundles">
            {authorIds.flatMap(authorId => {
                const bundlesByAuthor = relatedBundlesByAuthor[authorId];
                const author = authors.find(({ id }) => id === authorId);
                if (!author) {
                    return [];
                }

                const authorName = `${author.firstName} ${author.lastName}`;

                return bundlesByAuthor.map(bundle => {
                    return (
                        <RelatedTile
                            key={`author-related${bundle.bundleId}`}
                            bundle={bundle}
                            relatedType="authorRelated"
                            title={authorName}
                        />
                    );
                });
            })}
        </div>
    );
}

export function RelatedBundlesForProduct({
    relatedBundlesByProduct,
    productId,
    titleWithoutPrefix
}: {
    relatedBundlesByProduct: { readonly [productId: string]: BundleOut[] } | undefined;
    productId: string;
    titleWithoutPrefix: string | undefined;
}) {
    if (!relatedBundlesByProduct || Object.keys(relatedBundlesByProduct).length < 1) {
        return null;
    }

    const bundleList = relatedBundlesByProduct[productId];

    return (
        <div className="productBundles">
            {bundleList.map(bundle => (
                <RelatedTile
                    key={`product-related${bundle.bundleId}`}
                    bundle={bundle}
                    relatedType="productRelated"
                    title={titleWithoutPrefix}
                />
            ))}
        </div>
    );
}
